// Solène — Luxury Skincare House
export const META = { brand: 'Solène', tagline: 'Maison de soins · Provence', est: '1972' };
export const ROUTES = [
  { id: 'home', label: 'Maison' },
  { id: 'ritual', label: 'Le Rituel' },
  { id: 'atelier', label: 'L’Atelier' },
  { id: 'visit', label: 'Visit' },
];
export const RITUAL = [
  { step: 'Étape I', t: 'Cleanse', d: 'A milky cleanser of cold-pressed jojoba and Provençal almond, formulated to remove without stripping. Used morning and evening.', product: 'Lait Démaquillant nº 14', price: '€84 · 200 ml', img: 'https://images.pexels.com/photos/3373745/pexels-photo-3373745.jpeg?auto=compress&cs=tinysrgb&w=1200' },
  { step: 'Étape II', t: 'Treat', d: 'A treatment serum of immortelle from our own field, infused for nine months in Mediterranean sea-buckthorn oil. Apply six drops at night.', product: 'Sérum de Nuit nº 06', price: '€264 · 30 ml', img: 'https://images.pexels.com/photos/3762879/pexels-photo-3762879.jpeg?auto=compress&cs=tinysrgb&w=1200' },
  { step: 'Étape III', t: 'Restore', d: 'A nourishing balm of single-origin shea, rose otto and white cypress. Hand-poured in Aix in batches of two hundred jars.', product: 'Baume Suprême nº 22', price: '€186 · 50 ml', img: 'https://images.pexels.com/photos/4465137/pexels-photo-4465137.jpeg?auto=compress&cs=tinysrgb&w=1200' },
];
export const STORY = [
  { yr: 1972, t: 'Solène Bergeron founds the maison in Aix-en-Provence' },
  { yr: 1991, t: 'First atelier opened in the field at Les Lauves' },
  { yr: 2008, t: 'Certified organic by Ecocert · refillable jars introduced' },
  { yr: 2025, t: 'Carbon-neutral across the entire formulation chain' },
];
export const ESSAYS = [
  { d: 'Feb 2026', t: 'Why we wait nine months', sub: 'On the patience our immortelle infusion asks for', read: '8 min' },
  { d: 'Jan 2026', t: 'A short letter on shea', sub: 'Why we buy from one cooperative in Burkina Faso', read: '6 min' },
  { d: 'Dec 2025', t: 'Notes from Aix', sub: 'Our atelier diary, December', read: '4 min' },
];
